export const UI_KEYS = {
  HOME: {
    SECTIONS: {
      PAGE: 'HOME.PAGE',
      SEARCH: 'HOME.SEARCH',
      RESULTS: 'HOME.RESULTS',
    },
    DOM: {
      PAGE: 'home--page',
      SEARCH: 'home--search',
      RESULTS: 'home--results',
      TOUR_SIDEBAR: 'home--tour-sidebar',
      TOUR_SEARCH: 'home--tour-search',
      TOUR_SEARCH_BUTTON: 'home--tour-search-button',
      TOUR_FILTER: 'home--tour-filter',
      TOUR_PAGINATION: 'home--tour-pagination',
      TOUR_DOWNLOAD: 'home--tour-download',
      TOUR_RESULTS: 'home--tour-results',
      TOUR_FIRST_RESULT_ROW: 'home--tour-first-result-row',
    },
  },
  ADMIN_SURVEYS: {
    SECTIONS: {
      PAGE: 'ADMIN_SURVEYS.PAGE',
      FILTERS: 'ADMIN_SURVEYS.FILTERS',
      TABLE: 'ADMIN_SURVEYS.TABLE',
    },
    DOM: {
      PAGE: 'admin-surveys--page',
      FILTERS: 'admin-surveys--filters',
      FILTER_GROUP: 'admin-surveys--filter-group',
      TABLE: 'admin-surveys--table',
      SEARCH_INPUT: 'admin-surveys--search-input',
    },
    CONTROLS: {
      SEARCH_INPUT: 'ADMIN_SURVEYS.CONTROL.SEARCH_INPUT',
      FILTER_GROUP: 'ADMIN_SURVEYS.CONTROL.FILTER_GROUP',
      ADD_BUTTON: 'ADMIN_SURVEYS.CONTROL.ADD_BUTTON',
    },
  },
  ADMIN_UDW_BATCH_JOBS: {
    SECTIONS: {
      PAGE: 'ADMIN_UDW_BATCH_JOBS.PAGE',
      FEEDBACK: 'ADMIN_UDW_BATCH_JOBS.FEEDBACK',
      ACTIONS: 'ADMIN_UDW_BATCH_JOBS.ACTIONS',
      HISTORY: 'ADMIN_UDW_BATCH_JOBS.HISTORY',
    },
    DOM: {
      PAGE: 'admin-udw-batch-jobs--page',
      ALERT: 'admin-udw-batch-jobs--alert',
      ACTIONS: 'admin-udw-batch-jobs--actions',
      HISTORY: 'admin-udw-batch-jobs--history',
      HISTORY_TABLE: 'admin-udw-batch-jobs--history-table',
      READ_CARD: 'admin-udw-batch-jobs--read-card',
      PUSH_CARD: 'admin-udw-batch-jobs--push-card',
      READ_BUTTON: 'admin-udw-batch-jobs--read-button',
      PUSH_BUTTON: 'admin-udw-batch-jobs--push-button',
    },
    CONTROLS: {
      READ_TRIGGER: 'ADMIN_UDW_BATCH_JOBS.CONTROL.READ_TRIGGER',
      PUSH_TRIGGER: 'ADMIN_UDW_BATCH_JOBS.CONTROL.PUSH_TRIGGER',
    },
  },
} as const;

export type UiKeyNamespace = keyof typeof UI_KEYS;
